import React, { Component } from "react";
import { connect } from "react-redux";
import Button from "react-bootstrap-button-loader";
import { Field, reduxForm } from "redux-form";
import { processReset } from "Actions";
import { validateEmail } from "Constants";
import LoginErrorBar from "../starter/errorbar";
import LoginSuccessBar from "./successbar";
import LocaleStrings from "Languages";

class ProcessReset extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      showerror: false,
      alertMessage: "",
      showsuccess: false,
    };
  }

  componentWillMount() {}

  renderField(field) {
    var {
      meta: { touched, error },
    } = field;
    var className = `form-group login-element ${
      touched && error ? "has-danger" : ""
    }`;
    return (
      <div className={className}>
        <label>{field.label}</label>
        <input
          className="form-control"
          type={field.type}
          placeholder={field.placeholder}
          {...field.input}
        />
        <div className="text-help">{touched ? error : ""}</div>
      </div>
    );
  }

  onFormSubmit = (values) => {
    this.setState({ loading: true });
    this.props.processReset(values, (response) => {
      if (response.success === 1) {
        this.setState({
          ...this.state,
          alertMessage: LocaleStrings.reset_password_success,
          showerror: false,
          showsuccess: true,
          loading: false,
        });
        setTimeout(() => {
          this.props.history.push("/login");
        }, 3000);
      } else {
        this.setState({
          ...this.state,
          alertMessage: LocaleStrings.reset_password_failed_error,
          showerror: true,
          showsuccess: false,
          loading: false,
        });
        setTimeout(
          () => this.setState({ ...this.state, showerror: false }),
          3000
        );
      }
    });
  };

  render() {
    var { handleSubmit, invalid, pristine, submitting } = this.props;
    return (
      <div className="reset-form-container template-subcontainer">
        {this.state.showerror ? (
          <LoginErrorBar alertMessage={this.state.alertMessage} />
        ) : (
          ""
        )}
        {this.state.showsuccess ? (
          <LoginSuccessBar alertMessage={this.state.alertMessage} />
        ) : (
          ""
        )}
        <form onSubmit={handleSubmit(this.onFormSubmit)}>
          <div className="row">
            <div className="col-md-12 col-lg-12">&nbsp;</div>
          </div>
          <div className="row">
            <div className="col-md-12 col-lg-12 form-title horizontal-align-center">
              {LocaleStrings.reset_password}
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 col-lg-12">&nbsp;</div>
          </div>
          <div className="row">
            <div className="col-md-12 col-lg-12">
              <Field
                name="email"
                label={LocaleStrings.reset_password_form_label_email}
                placeholder={LocaleStrings.reset_password_form_ph_email}
                type="email"
                component={this.renderField}
              />
              <Field
                name="passcode"
                label={
                  LocaleStrings.reset_password_form_label_confirmation_code
                }
                placeholder={
                  LocaleStrings.reset_password_form_ph_confirmation_code
                }
                type="text"
                component={this.renderField}
              />
              <Field
                name="password"
                label={LocaleStrings.reset_password_form_label_new_password}
                type="password"
                placeholder={LocaleStrings.reset_password_form_ph_new_password}
                component={this.renderField}
              />

              <div className="form-group login-element top-buffer">
                <Button
                  className="btn btn-default btn-social-login"
                  loading={this.state.loading}
                  type="submit"
                  disabled={pristine || invalid || submitting}
                >
                  {LocaleStrings.button_change_password}
                </Button>
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

function validate(values) {
  var errors = {};

  if (!values.email) {
    errors.email = LocaleStrings.reset_password_form_validation_email_required;
  }

  if (!values.password) {
    errors.password =
      LocaleStrings.reset_password_form_validation_password_required;
  }

  if (!values.passcode) {
    errors.passcode =
      LocaleStrings.reset_password_form_validation_confirmation_code_required;
  }

  if (values.email) {
    if (!validateEmail(values.email)) {
      errors.email = LocaleStrings.reset_password_form_validation_email_invalid;
    }
  }
  return errors;
}

function mapStateToProps(state) {
  return {
    session: state.session,
    user: state.user,
  };
}

export default reduxForm({
  validate,
  form: "ProcessResetForm",
})(connect(mapStateToProps, { processReset })(ProcessReset));
